export const SELECTED_TOGGLE_SETTINGS = {
  icon: "lucide:check",
  classes: "ml-auto size-4 text-primary",
  dropdownClass: "min-w-36",
};
